import workLanguage from '../components/work-languages';
import workChildren from '../components/work-children';
import workFormation from '../components/work-formation';
import viaCep from '../components/via-cep';

export default {
  init() {
    workLanguage.fire();
    workChildren.fire();
    workFormation.fire();
    viaCep.fire();
  },

  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateWork.js